import React from 'react';
import styled, { css } from "styled-components";


const backdrop = (WrappedComponent) => {

  const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  ${props =>
    props.disappear &&
      css`
      display: block; /* show */
  `}
  `;

  const WithBackdrop = props => {
    return (
      <DarkBackground disappear={true} >
        <WrappedComponent {...props} />
      </DarkBackground>
    );
  };
  WithBackdrop.displayName = `WithBackdrop(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;
  return WithBackdrop;
};

export default backdrop;